import {
  createAction,
  createSlice,
  type PayloadAction,
} from "@reduxjs/toolkit";
import type { ILatestUpdatedFiles } from "InterfacesTypes/interfaces";

export interface ILatestUpdatedFilesState {
  recentlyUpdatedFiles: ILatestUpdatedFiles[];
  loading: boolean;
  error: string | null;
}

const initialState: ILatestUpdatedFilesState = {
  recentlyUpdatedFiles: [],
  loading: false,
  error: null,
};

export const fetchRecentlyUpdatedFiles = createAction(
  "recentlyUpdatedFiles/fetchRecentlyUpdatedFiles"
);

export const recentlyUpdatedFilesSlice = createSlice({
  name: "recentlyUpdatedFiles",
  initialState,
  reducers: {
    fetchStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchSuccess(state, action: PayloadAction<ILatestUpdatedFiles[]>) {
      state.loading = false;
      state.recentlyUpdatedFiles = action.payload;
    },
    fetchFailure(state, action: PayloadAction<string | null | undefined>) {
      state.loading = false;
      state.error = action.payload ?? "Något gick fel";
    },

    setRecentlyUpdatedFiles(
      state,
      action: PayloadAction<ILatestUpdatedFiles[]>
    ) {
      state.recentlyUpdatedFiles = action.payload;
    },
  },
});

export const {
  fetchStart,
  fetchSuccess,
  fetchFailure,
  setRecentlyUpdatedFiles,
} = recentlyUpdatedFilesSlice.actions;

export const recentlyUpdatedFilesReducer = recentlyUpdatedFilesSlice.reducer;
